var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSeachBarCross = function SvgSeachBarCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Cancel/Cross/Close"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M12 10l8 8 8-8a1.415 1.415 0 012 2l-8 8 8 8a1.415 1.415 0 01-2 2l-8-8-8 8a1.415 1.415 0 01-2-2l8-8-8-8a1.415 1.415 0 012-2z"
  }))));
};
export default SvgSeachBarCross;